import { useMemo } from 'react';
import { useStrapiApi, useStrapiParams } from '@/hooks';
import type { ProductCatalog, StrapiListRequest, StrapiListResponse } from '@/interfaces/strapi';
import type { IDropdownItem } from '@/interfaces/AUI/IDropdown.interface';

import { getCatalogProducts } from '@/services/strapi';

export function useCatalogProductOptions() {
	const params = useStrapiParams({
		page: 1,
		pageSize: 500,
		populate: {},
		sort: 'name',
	});

	const { data, loading } = useStrapiApi<StrapiListResponse<ProductCatalog>, StrapiListRequest>(getCatalogProducts, {
		autoFetch: true,
		params,
	});

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const items = data?.list ?? [];

	const options: IDropdownItem[] = useMemo(
		() =>
			items.map((p: ProductCatalog) => ({
				label: p.name,
				value: p.id,
			})),
		[items],
	);

	const idToLabel = useMemo(() => {
		const m = new Map<string | number, string>();
		options.forEach((o) => m.set(o.value, o.label));
		return m;
	}, [options]);

	return { options, idToLabel, loading };
}
